
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5390',
  depVersions: {
  "data-privacy-request-ui": "static-1.5390",
  "data-fetching-client": "static-1.9542",
  "head-dlb": "static-1.4884",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7872",
  "hub-http-shared-msw-handlers": "static-1.9635",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11308",
  "I18n": "static-7.1593",
  "jasmine-runner": "static-1.6335",
  "privacy-center-public-service-types": "static-1.4653",
  "quartz": "static-1.6815",
  "react-dlb": "static-1.74",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5446",
  "UIComponents": "static-3.8255",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.82",
  "foundations-assets": "static-1.4706",
  "foundations-components": "static-1.7646",
  "foundations-components-test-utils": "static-1.5129",
  "foundations-theming": "static-1.4277",
  "hub-http": "static-1.6083",
  "quartz-config": "static-1.593",
  "quartz-core": "static-1.6034",
  "quick-fetch": "static-1.3799",
  "raven": "static-3.5768",
  "react": "static-7.182",
  "react-rhumb": "static-1.16515",
  "SharedI18nStrings": "static-1.181",
  "ui-addon-i18n": "static-1.11011",
  "usage-tracker": "static-1.7200",
  "usage-tracker-anonymous": "static-1.5617",
  "usage-tracker-core": "static-1.7050",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3957",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3290",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3092",
  "quartz-webpack": "static-1.3039",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.78",
  "HeadJS": "static-2.728",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2983",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "ts-schema": "static-1.3966",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "react-utils": "static-2.5236",
  "StyleGuideUI": "static-3.485",
  "jasmine": "static-4.4191",
  "rpc-client-utils": "static-1.4507",
  "HubStyle": "static-2.11616",
  "ui-addon-draggable": "static-3.4633",
  "cssUtils": "static-1.758",
  "hs-story-utils": "static-1.9291",
  "icons": "static-2.635",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.95",
  "ui-images": "static-2.1118",
  "bend-plugin-foundations-components": "static-1.3915",
  "floating-ui": "static-1.52",
  "foundations-theming-specialty": "static-1.1993",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1394",
  "ui-fonts": "static-1.570",
  "foundations-components-legacy": "static-1.671",
  "bend-plugin-foundations-theming": "static-1.2760",
  "foundations-theming-base": "static-1.3262",
  "stylex": "static-1.28",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.813",
  "hubspotter-http": "static-1.4539",
  "mobile-manifest-mixins": "static-1.503",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.490",
  "quartz-head": "static-1.480",
  "quartz-i18n": "static-1.490",
  "quartz-routing": "static-1.245",
  "quartz-test": "static-1.490",
  "quartz-tracking": "static-1.194",
  "usage-tracker-container": "static-1.7190",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3018",
  "chirp-fetch": "static-1.1748",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.66",
  "sassPrefix": "static-1.153",
  "hubspotter-http-shared-msw-handlers": "static-1.9633",
  "usage-tracker-session-replay": "static-1.4886",
  "amplitude-session-replay-browser": "static-1.56"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5390",
  "data-fetching-client": "/data-fetching-client/static-1.9542",
  "head-dlb": "/head-dlb/static-1.4884",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7872",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9635",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11308",
  "I18n": "/I18n/static-7.1593",
  "jasmine-runner": "/jasmine-runner/static-1.6335",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4653",
  "quartz": "/quartz/static-1.6815",
  "react-dlb": "/react-dlb/static-1.74",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5446",
  "UIComponents": "/UIComponents/static-3.8255",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "foundations-assets": "/foundations-assets/static-1.4706",
  "foundations-components": "/foundations-components/static-1.7646",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5129",
  "foundations-theming": "/foundations-theming/static-1.4277",
  "hub-http": "/hub-http/static-1.6083",
  "quartz-config": "/quartz-config/static-1.593",
  "quartz-core": "/quartz-core/static-1.6034",
  "quick-fetch": "/quick-fetch/static-1.3799",
  "raven": "/raven/static-3.5768",
  "react": "/react/static-7.182",
  "react-rhumb": "/react-rhumb/static-1.16515",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11011",
  "usage-tracker": "/usage-tracker/static-1.7200",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5617",
  "usage-tracker-core": "/usage-tracker-core/static-1.7050",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3290",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3092",
  "quartz-webpack": "/quartz-webpack/static-1.3039",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.78",
  "HeadJS": "/HeadJS/static-2.728",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2983",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "ts-schema": "/ts-schema/static-1.3966",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "react-utils": "/react-utils/static-2.5236",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "jasmine": "/jasmine/static-4.4191",
  "rpc-client-utils": "/rpc-client-utils/static-1.4507",
  "HubStyle": "/HubStyle/static-2.11616",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4633",
  "cssUtils": "/cssUtils/static-1.758",
  "hs-story-utils": "/hs-story-utils/static-1.9291",
  "icons": "/icons/static-2.635",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.95",
  "ui-images": "/ui-images/static-2.1118",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3915",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1993",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1394",
  "ui-fonts": "/ui-fonts/static-1.570",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.671",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2760",
  "foundations-theming-base": "/foundations-theming-base/static-1.3262",
  "stylex": "/stylex/static-1.28",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.813",
  "hubspotter-http": "/hubspotter-http/static-1.4539",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.503",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.490",
  "quartz-head": "/quartz-head/static-1.480",
  "quartz-i18n": "/quartz-i18n/static-1.490",
  "quartz-routing": "/quartz-routing/static-1.245",
  "quartz-test": "/quartz-test/static-1.490",
  "quartz-tracking": "/quartz-tracking/static-1.194",
  "usage-tracker-container": "/usage-tracker-container/static-1.7190",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3018",
  "chirp-fetch": "/chirp-fetch/static-1.1748",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.66",
  "sassPrefix": "/sassPrefix/static-1.153",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9633",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4886",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56"
}
};
